import React, { createContext, useContext, useState } from 'react';

interface PlanLimitContextData {
  isBannerVisible: boolean;
  showBanner: () => void;
  hideBanner: () => void;
}

const PlanLimitContext = createContext<PlanLimitContextData>(
  {} as PlanLimitContextData,
);

export const PlanLimitProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  const showBanner = () => {
    setIsBannerVisible(true);
  };

  const hideBanner = () => {
    setIsBannerVisible(false);
  };

  return (
    <PlanLimitContext.Provider
      value={{
        isBannerVisible,
        showBanner,
        hideBanner,
      }}>
      {children}
    </PlanLimitContext.Provider>
  );
};

export const usePlanLimit = () => {
  const context = useContext(PlanLimitContext);

  if (!context) {
    throw new Error(
      'usePlanLimit deve ser usado dentro de um PlanLimitProvider',
    );
  }

  return context;
};
